module.exports = __webpack_public_path__ + "media/images/squared-away-logo-horizontal-649285ca43ca8b0b941c381d524e55be.png";